import React, { Component, useState } from "react";
import "./topbar.css";
import { FiMessageSquare, FiUser } from "react-icons/all";
import ProfileComponent from "../ProfileComponent";

export default function Topbar() {
  const [openProfileComponent, setOpenProfileComponent] = useState(false);

  return (
    <div className="topbar">
      <div className="topbarWrapper">
        <div className="topLeft">
          <span className="logo">Northway Commerce Hub</span>
        </div>
        <div className="topRight">
          <div className="topbarIconContainer">
            <FiMessageSquare />
            <span className="topIconBadge">2</span>
          </div>
          <div className="topbarIconContainer">
            <ProfileComponent />
          </div>
        </div>
      </div>
    </div>
  );
}
